import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import firebaseMessagingService from '../services/firebase/messaging';
import { setDeviceToken } from '../slice/authSlice';
import { toast } from 'react-toastify';

export const useFirebase = () => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const initializeFirebase = async () => {
      try {
        // console.log('Initializing Firebase...');

        // Initialize Firebase Messaging
        const token = await firebaseMessagingService.initialize();

        if (token) {
          // Store device token in Redux
          dispatch(setDeviceToken(token));
          // console.log('Firebase initialized successfully with token:', token);
        } else {
          console.warn('Firebase initialized but no token generated');
        }

        setIsInitialized(true);
      } catch (error) {
        console.error('Failed to initialize Firebase:', error);
        toast.error('Failed to initialize push notifications');
      } finally {
        setIsInitializing(false);
      }
    };

    // Only initialize if in browser environment
    if (typeof window !== 'undefined') {
      initializeFirebase();
    } else {
      setIsInitializing(false);
    }
  }, [dispatch]);

  return {
    isInitialized,
    isInitializing,
    deviceToken: firebaseMessagingService.getDeviceToken(),
  };
};